import React from 'react';
import modules_1a8f5c5e from './label.module.scss.js';

const Label = ({ labelType, children }) => {
    const renderLabel = () => (React.createElement("div", { className: modules_1a8f5c5e[`label-${labelType}-container`] }, children));
    return renderLabel();
};

export { Label as default };
//# sourceMappingURL=label.js.map
